import React, { useContext, useEffect, useState, useRef } from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import {
  Typography,
  Grid,
  Divider,
  useTheme,
  useMediaQuery,
  CircularProgress,
  Stack,
  Box,
  Popover,
  Select,
  MenuItem,
  FormControl,
  TextField,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  IconButton,
  Tooltip,
} from '@mui/material';
import { datacontext } from 'modules/AppLayout/AppLayout';
import {
  Pendingwarning,
  Redwarning,
} from 'component/BuyersMarketplace/MakeOffers';
import {
  poppins500,
  poppins400,
  poppins300,
  poppins700,
} from 'theme/common.style';
import { useParams } from 'react-router-dom';
import Swal from 'sweetalert2';
import EnhancedTable from 'component/BuyerRegistration/Table';
import {
  forwardOfferToBuyer,
  stageTwoSwitching,
  forwardOfferToVendor,
  Moxoseparationinlisting,
  getApiCall,
} from 'api/apiService';
import { ChevronLeft, ChevronRight } from '@mui/icons-material';
import Avatar from 'antd/es/avatar/avatar';
import BadgeButton from 'component/BuyerRegistration/components/BadgeButton';
import dayjs from 'dayjs';
import { LocalizationProvider, TimePicker } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { GET_BINDERID } from 'constant/app.config';
import Moxochat from 'component/Moxochat/Moxochat';
import { pick_date } from 'component/PropertyCreation/PropertyCreation.style';
import Loading from 'assets/images/loading.png';
import ShareOfferWithMarketPlace from 'component/BuyerRegistration/ShareOfferWithMarketPlace';
import moment from 'moment';
import CommonPdfViewer from 'component/Common/CommonPdfViewer';
import NameTooltip from 'component/Common/NameTooltip';

const WarningIcon = () => {
  return (
    <svg
      width="18"
      height="16"
      viewBox="0 0 18 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M17.4901 11.4607L11.5789 1.45599C11.0462 0.555115 10.0621 0 8.99672 0C7.9314 0 6.94728 0.555115 6.41462 1.45599L0.399495 11.632C-0.133165 12.5329 -0.133165 13.6431 0.399495 14.544C0.932154 15.4449 1.91628 16 2.9816 16H15.0119C15.0152 16 15.0184 16 15.0184 16C16.6651 16 18 14.6962 18 13.088C18 12.4853 17.8116 11.9239 17.4901 11.4607ZM10.2732 12.4345C10.2732 13.1229 9.73078 13.6495 9 13.6495C8.26922 13.6495 7.72681 13.1229 7.72681 12.4345V12.406C7.72681 11.7208 8.26922 11.1911 9 11.1911C9.73078 11.1911 10.2732 11.7177 10.2732 12.406V12.4345ZM10.3024 4.24425L9.67232 9.61776C9.6301 10.0048 9.36702 10.2458 9 10.2458C8.63298 10.2458 8.3699 10.0016 8.32768 9.61776L7.69758 4.24108C7.65536 3.82554 7.88599 3.5115 8.28221 3.5115H9.71454C10.1108 3.51467 10.3446 3.82871 10.3024 4.24425Z"
        fill="#34C759"
      />
    </svg>
  );
};

const WarningIconRED = () => {
  return (
    <svg
      width="18"
      height="16"
      viewBox="0 0 18 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M17.4901 11.4607L11.5789 1.45599C11.0462 0.555115 10.0621 0 8.99672 0C7.9314 0 6.94728 0.555115 6.41462 1.45599L0.399495 11.632C-0.133165 12.5329 -0.133165 13.6431 0.399495 14.544C0.932154 15.4449 1.91628 16 2.9816 16H15.0119C15.0152 16 15.0184 16 15.0184 16C16.6651 16 18 14.6962 18 13.088C18 12.4853 17.8116 11.9239 17.4901 11.4607ZM10.2732 12.4345C10.2732 13.1229 9.73078 13.6495 9 13.6495C8.26922 13.6495 7.72681 13.1229 7.72681 12.4345V12.406C7.72681 11.7208 8.26922 11.1911 9 11.1911C9.73078 11.1911 10.2732 11.7177 10.2732 12.406V12.4345ZM10.3024 4.24425L9.67232 9.61776C9.6301 10.0048 9.36702 10.2458 9 10.2458C8.63298 10.2458 8.3699 10.0016 8.32768 9.61776L7.69758 4.24108C7.65536 3.82554 7.88599 3.5115 8.28221 3.5115H9.71454C10.1108 3.51467 10.3446 3.82871 10.3024 4.24425Z"
        fill="#FF3B30"
      />
    </svg>
  );
};

const WarningIconYELLOW = () => {
  return (
    <svg
      width="18"
      height="16"
      viewBox="0 0 18 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M17.4901 11.4607L11.5789 1.45599C11.0462 0.555115 10.0621 0 8.99672 0C7.9314 0 6.94728 0.555115 6.41462 1.45599L0.399495 11.632C-0.133165 12.5329 -0.133165 13.6431 0.399495 14.544C0.932154 15.4449 1.91628 16 2.9816 16H15.0119C15.0152 16 15.0184 16 15.0184 16C16.6651 16 18 14.6962 18 13.088C18 12.4853 17.8116 11.9239 17.4901 11.4607ZM10.2732 12.4345C10.2732 13.1229 9.73078 13.6495 9 13.6495C8.26922 13.6495 7.72681 13.1229 7.72681 12.4345V12.406C7.72681 11.7208 8.26922 11.1911 9 11.1911C9.73078 11.1911 10.2732 11.7177 10.2732 12.406V12.4345ZM10.3024 4.24425L9.67232 9.61776C9.6301 10.0048 9.36702 10.2458 9 10.2458C8.63298 10.2458 8.3699 10.0016 8.32768 9.61776L7.69758 4.24108C7.65536 3.82554 7.88599 3.5115 8.28221 3.5115H9.71454C10.1108 3.51467 10.3446 3.82871 10.3024 4.24425Z"
        fill="#FF9500"
      />
    </svg>
  );
};

const Edit = () => {
  return (
    <svg
      width="21"
      height="21"
      viewBox="0 0 21 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_31572_232178)">
        <path
          d="M3.5 17.5003H7L16.1875 8.31276C16.6516 7.84864 16.9124 7.21914 16.9124 6.56276C16.9124 5.90639 16.6516 5.27689 16.1875 4.81276C15.7234 4.34864 15.0939 4.08789 14.4375 4.08789C13.7811 4.08789 13.1516 4.34864 12.6875 4.81276L3.5 14.0003V17.5003Z"
          stroke="#529AEE"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M11.8125 5.6875L15.3125 9.1875"
          stroke="#529AEE"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_31572_232178">
          <rect width="21" height="21" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

const Exclamatory = ({ matchesxs }) => {
  return (
    <svg
      width={matchesxs ? '24' : '32'}
      height={matchesxs ? '24' : '32'}
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle
        cx="16.0026"
        cy="16.0007"
        r="14.6667"
        stroke="#F93939"
        stroke-width="2"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M15.4688 19.7331V9.06641H16.5354V19.7331H15.4688ZM16.5354 21.8664V22.9437H15.4688V21.8664H16.5354Z"
        fill="#FF3B30"
      />
    </svg>
  );
};

const ForwardOff = ({ color }) => {
  return (
    <svg
      width="23"
      height="23"
      viewBox="0 0 23 23"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10.25 10.4361H8.65C7.33768 10.4356 6.05019 10.774 4.9267 11.4145C3.80322 12.055 2.88648 12.9734 2.2756 14.0703C2.25843 13.8667 2.24989 13.6626 2.25 13.4583C2.25 9.2854 5.8316 5.90278 10.25 5.90278V2.125L18.25 8.16944L10.25 14.2139V10.4361Z"
        fill={color ? '#a7a7a7' : '#666666'}
      />
    </svg>
  );
};

const Warning = () => {
  return (
    <svg
      width="38"
      height="36"
      viewBox="0 0 38 36"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        width="37.5797"
        height="36"
        rx="18"
        fill="#10D35E"
        fill-opacity="0.1"
      />
      <path
        d="M27.0817 21.4607L21.3085 11.456C20.7883 10.5551 19.8271 10 18.7866 10C17.7462 10 16.7851 10.5551 16.2648 11.456L10.3902 21.632C9.86994 22.5329 9.86994 23.6431 10.3902 24.544C10.9104 25.4449 11.8715 26 12.912 26H24.6614C24.6646 26 24.6677 26 24.6677 26C26.276 26 27.5797 24.6962 27.5797 23.088C27.5797 22.4853 27.3957 21.9239 27.0817 21.4607ZM20.0333 22.4345C20.0333 23.1229 19.5036 23.6495 18.7898 23.6495C18.0761 23.6495 17.5464 23.1229 17.5464 22.4345V22.406C17.5464 21.7208 18.0761 21.1911 18.7898 21.1911C19.5036 21.1911 20.0333 21.7177 20.0333 22.406V22.4345ZM20.0619 14.2443L19.4465 19.6178C19.4052 20.0048 19.1483 20.2458 18.7898 20.2458C18.4314 20.2458 18.1745 20.0016 18.1332 19.6178L17.5178 14.2411C17.4766 13.8255 17.7019 13.5115 18.0888 13.5115H19.4877C19.8747 13.5147 20.1031 13.8287 20.0619 14.2443Z"
        fill="#10D35E"
      />
    </svg>
  );
};

function CommenceStageTwo(props) {
  const {
    openCommenceStageTwo,
    onCloseCommenceStageTwo,
    getListInfo,
    activityfun,
    offerdata,
    stageData,
    stage2AcceptanceCertificate,
    setStage2AcceptanceCertificate,
  } = props;
  const { setIschatopen } = useContext(datacontext);
  const [modalIsOpen, setModalIsOpen] = useState(false);
  const { bannerApiTrigger } = useContext(datacontext);

  const sliderRef = useRef(null);

  const [isAtStart, setIsAtStart] = useState(true);
  const [isAtEnd, setIsAtEnd] = useState(false);
  const [showChevrons, setShowChevrons] = useState(false);

  const isInactive = ['Pause', 'End'].includes(
    stageData?.PropertyDetails?.timerStatus
  );
  const updateScrollButtons = () => {
    const el = sliderRef.current;
    if (!el) return;

    setIsAtStart(el.scrollLeft <= 0);
    setIsAtEnd(el.scrollLeft + el.clientWidth >= el.scrollWidth - 1);
  };

  useEffect(() => {
    const el = sliderRef.current;
    if (!el) return;

    const updateScrollButtons = () => {
      setIsAtStart(el.scrollLeft <= 5);
      setIsAtEnd(el.scrollLeft + el.clientWidth >= el.scrollWidth - 5);
    };

    updateScrollButtons();
    el.addEventListener('scroll', updateScrollButtons, { passive: true });

    return () => el.removeEventListener('scroll', updateScrollButtons);
  }, []);

  const scrollRight = () => {
    const el = sliderRef.current;
    if (!el) return;

    const card = el.querySelector('[data-index="0"]');
    if (!card) return;

    const gap = 10;
    const cardWidth = card.offsetWidth + gap;

    const currentIndex = Math.round(el.scrollLeft / cardWidth);
    const nextIndex = currentIndex + 2;

    el.scrollTo({
      left: nextIndex * cardWidth,
      behavior: 'smooth',
    });
  };

  const scrollLeft = () => {
    const el = sliderRef.current;
    if (!el) return;

    const card = el.querySelector('[data-index="0"]');
    if (!card) return;

    const gap = 10;
    const cardWidth = card.offsetWidth + gap;

    const currentIndex = Math.round(el.scrollLeft / cardWidth);
    const prevIndex = Math.max(0, currentIndex - 2);

    el.scrollTo({
      left: prevIndex * cardWidth,
      behavior: 'smooth',
    });
  };

  const filteredBuyers =
    stageData?.BuyerRegisterDetails?.filter((item) => {
      const isNewOffer = item?.buyerOfferDetails?.isNew == 1;
      const isVendorNotified =
        item?.buyerOfferDetails?.offerStatusVendor == 'Vendor Notified';
      const offerStatusCode = item?.buyerOfferDetails?.offerStatusCode;

      return (
        (isNewOffer &&
          offerStatusCode !== 'BuyerAccPrivate001' &&
          offerStatusCode !== 'BuyerAcc001') ||
        (item?.buyerOfferDetails?.isNew == 0 && isVendorNotified)
      );
    }) || [];
  const isOdd = filteredBuyers.length % 2 !== 0;
  useEffect(() => {
    setShowChevrons(filteredBuyers.length > 2);
  }, [filteredBuyers.length]);

  useEffect(() => {
    setShowChevrons(filteredBuyers.length > 2);
  }, [filteredBuyers.length]);

  const directcomm = (userId) => {
    const data = localStorage.getItem('userDetail');
    const userDetail = JSON.parse(data);
    const agentId = userDetail?.userId;
    const propertyId = params?.dashboardId;
    const userType = userDetail?.primaryUserType;

    if (userId) {
      getApiCall(
        GET_BINDERID +
          `/${agentId}` +
          `/${userId}` +
          `/${propertyId}` +
          `/${userType}`
      ).then((resp) => {
        onShowChat(resp?.data?.binderId);
      });
    }
  };

  const onShowChat = (binderId) => {
    setIschatopen(binderId);
    setModalIsOpen(true);
  };
  const theme = useTheme();
  const matchessm = useMediaQuery(theme.breakpoints.down('sm'));
  const matchesxs = useMediaQuery(theme.breakpoints.down(500));
  const matches700 = useMediaQuery(theme.breakpoints.down(700));
  const isXsScreen = useMediaQuery(theme.breakpoints.down('xs'));

  const params = useParams();
  const [loader, setLoader] = useState(false);
  const [loaderStage2, setLoaderStage2] = useState(false);
  const [forwardOfferCheckList, setForwardOfferCheckList] = useState([]);
  const data = stageData?.PropertyDetails?.vendorStatus;
  const counterOfferPrice = stageData?.PropertyDetails?.vendorStatus?.price;
  const lowestAcceptedOffer = stageData?.lowestAcceptedOffer;
  const lowestAcceptedOfferFile = stageData?.lowestAcceptedOfferFile;
  const lowestAcceptedOfferIsConditional =
    stageData?.lowestAcceptedOfferIsConditional;
  const [shareMarketPlace, setShareMarketPlace] = useState(false);

  const [unhandledOffersCount, setUnhandledOffersCount] = useState(0);
  const [st2InitialTimer, setSt2InitialTimer] = useState(
    stageData?.stageTwoCondition?.stage2Timer
  );
  const [st2ResetTimer, setSt2ResetTimer] = useState(
    stageData?.stageTwoCondition?.TimerReset
  );

  useEffect(() => {
    if (stageData?.stageTwoCondition?.stage2Timer !== undefined) {
      setSt2InitialTimer(stageData.stageTwoCondition.stage2Timer);
      setConfirmedTimer(stageData.stageTwoCondition.stage2Timer);
    }
    if (stageData?.stageTwoCondition?.TimerReset !== undefined) {
      setSt2ResetTimer(stageData.stageTwoCondition.TimerReset);
    }
  }, [
    stageData?.stageTwoCondition?.stage2Timer,
    stageData?.stageTwoCondition?.TimerReset,
  ]);
  const [timerresetpopup, setTimerresetpopup] = useState(false);
  const [lessthanstage2, setLessthanstage2] = useState(false);
  const [timerreset, setTimerreset] = useState(30);
  const [timer, setTimer] = useState(dayjs().set('hour', 0).set('minute', 30));

  useEffect(() => {
    const count = stageData?.BuyerRegisterDetails?.reduce((acc, offer) => {
      const isNewOffer = offer?.buyerOfferDetails?.isNew == 1;
      const isVendorNotified =
        offer?.buyerOfferDetails?.offerStatusVendor == 'Vendor Notified';
      const offerStatusCode = offer?.buyerOfferDetails?.offerStatusCode;
      return (
        acc +
        ((isNewOffer &&
          offerStatusCode != 'BuyerAccPrivate001' &&
          offerStatusCode != 'BuyerAcc001') ||
        (offer?.buyerOfferDetails?.isNew == 0 && isVendorNotified)
          ? 1
          : 0)
      );
    }, 0);

    setUnhandledOffersCount(count);
  }, [stageData]);

  const isUnhandledOffer = (offer) => {
    const isNew = offer?.buyerOfferDetails?.isNew == 1;
    const statusCode = offer?.buyerOfferDetails?.offerStatusCode;
    const isVendorNotified =
      offer?.buyerOfferDetails?.offerStatusVendor === 'Vendor Notified';

    const case1 =
      isNew &&
      statusCode !== 'BuyerAccPrivate001' &&
      statusCode !== 'BuyerAcc001';

    const case2 = offer?.buyerOfferDetails?.isNew == 0 && isVendorNotified;

    return case1 || case2;
  };

  const sortedRows = React.useMemo(() => {
    const rows = stageData?.BuyerRegisterDetails || [];

    const unhandled = rows.filter((r) => isUnhandledOffer(r));
    const handled = rows.filter((r) => !isUnhandledOffer(r));

    return [...handled, ...unhandled];
  }, [stageData]);

  const rowsWithFlag = sortedRows?.map((r) => ({
    ...r,
    isUnhandled: isUnhandledOffer(r),
  }));

  const conditionToggle = stageData?.stageTwoCondition?.UnconditionalOnly;
  const handleStage2CancelClick = async () => {
    setForwardOfferCheckList([]);
    onCloseCommenceStageTwo();
    await getListInfo();
  };

  const [isChangedSet, setIsChangedSet] = useState(0);

  const isNotEmptyArray = (arr) =>
    Array.isArray(arr) &&
    arr.length > 0 &&
    !arr.every((item) => Array.isArray(item) && item.length === 0);

  const moxoapis = (res) => {
    if (isNotEmptyArray(res?.dataForOtherBuyersAck))
      Moxoseparationinlisting(
        'dataForBuyerAckNotST2',
        res?.dataForOtherBuyersAck
      ); //1
    if (isNotEmptyArray(res?.dataForBuyerAck))
      Moxoseparationinlisting('dataForBuyerAckST2', res?.dataForBuyerAck); //2
    if (isNotEmptyArray(res?.dataForVendorAck))
      Moxoseparationinlisting('dataForVendorAck', res?.dataForVendorAck); //3
  };

  const forwardOfferToBuyerFunction = (selectedIdsFromCheckbox = []) => {
    setLoaderStage2(true);
    const getRowMatchId = (row) =>
      row?.buyerOfferDetails?.offerUniqueId ?? row?.buyerDetails?.user?.userId;

    const usedList =
      selectedIdsFromCheckbox.length > 0
        ? selectedIdsFromCheckbox
        : forwardOfferCheckList;

    const selectedIdSet = new Set(usedList.filter(Boolean).map(String));
    const selectedBuyers = rowsWithFlag.filter((row) => {
      const rowId = getRowMatchId(row);
      return rowId != null && selectedIdSet.has(String(rowId));
    });

    const newArr = Array.from(
      new Set(usedList.filter((id) => id && id != ''))
    ).map((id) => ({ offerUniqueId: id }));

    const buyerListHtml =
      selectedBuyers.length > 0
        ? `
  <br/>
  <div style="text-align:left; margin:0 auto; padding-left: 20px;">
  <ul style="padding-left: 20px;">
    ${selectedBuyers
      .map((row) => {
        const firstName = row?.buyerDetails?.user?.userName || '';
        const lastName = row?.buyerDetails?.user?.userSurName || '';
        return `<li><b>- ${firstName} ${lastName}</b></li>`;
      })
      .join('')}
  </ul>
  </div>
`
        : '';

    var txt = data?.price;
    var vendorOffer = txt.match(/\d/g);
    vendorOffer = vendorOffer.join('');

    const hasChanges =
      confirmedTimer != st2InitialTimer ||
      st2ResetTimer != stageData?.stageTwoCondition?.TimerReset ||
      conditionType !== conditionToggle;
    setIsChangedSet(hasChanges ? 1 : 0);

    const UnconditionalOnly = conditionType ? '1' : '0';
    const initialTimer = parseInt(confirmedTimer) || parseInt(st2InitialTimer);
    const timerReset = isChangedSet
      ? st2ResetTimer
      : stageData?.stageTwoCondition?.TimerReset;

    let input = {
      propertyId: params?.dashboardId,
      campaignId: stageData?.PropertyDetails?.campaignId,
      offerUniqueId: newArr,
      timerStage: 'ST2',
      timerStatus: 'Start',
      vendorOfferPrice: vendorOffer,
      isChangedSet: hasChanges ? 1 : 0,
      stageTwoTime: initialTimer,
      stageTwo: {
        UnconditionalOnly: UnconditionalOnly,
        VerifiedBuyers: '0',
        MinimumIncrement: 300,
        TimerReset: timerReset,
        stage2Timer: initialTimer,
      },
    };

    stageTwoSwitching(input)
      .then((res) => {
        if (res?.status == '1') {
          bannerApiTrigger();
          // if (isNotEmptyArray(res?.dataForAutoOffer)) {
          //   let params = { requestData: res?.dataForAutoOffer };
          //   postApiCall(BUYER_AUTO_OFFER, params);
          // }
          setLoaderStage2(false);
          setOpen(false);
          onCloseCommenceStageTwo();
          Swal.fire({
            title: res?.heading ? res?.heading : 'Success',
            // text: res?.message,
            html: `
      <div>${res?.message}</div>
      ${buyerListHtml}
    `,
            showDenyButton: false,
            showCancelButton: false,
            icon: 'success',
            confirmButtonText: 'Close',
          }).then((result) => {
            if (result.isConfirmed) {
              setOpen(false);
              onCloseCommenceStageTwo();
              getListInfo();
              activityfun();
              offerdata();
              moxoapis(res);
            } else if (result.isDenied) {
              return;
            }
          });
        } else {
          setLoaderStage2(false);
          setOpen(false);
          onCloseCommenceStageTwo();
          Swal.fire({
            title: res?.heading ? res?.heading : 'Error',
            text: res?.message,
            showDenyButton: false,
            showCancelButton: false,
            icon: 'error',
            confirmButtonText: 'Close',
          }).then((result) => {
            if (result.isConfirmed) {
            } else if (result.isDenied) {
              return;
            }
          });
        }
      })
      .catch(() => setLoaderStage2(false));
  };

  const [conditionType, setConditionType] = useState();

  const handleToggle = () => {
    setConditionType((prev) => {
      const newConditionType = !prev;
      setIsChangedSet(newConditionType !== conditionToggle ? true : false);
      return newConditionType;
    });
  };

  useEffect(() => {
    setConditionType(
      stageData?.stageTwoCondition?.UnconditionalOnly == 1 ? true : false
    );
    setIsChangedSet(0);
  }, []);
  function CircularProgressWithProfile(props) {
    let { data } = props;
    return (
      <Box sx={{ position: 'relative', display: 'inline-flex' }}>
        <CircularProgress
          variant="determinate"
          value={100}
          sx={{ color: '#C4C4C461' }}
          thickness={5}
          size={matchesxs ? 60 : 80}
        />
        <CircularProgress
          variant="determinate"
          value={data}
          sx={{ color: '#10D35E', position: 'absolute' }}
          thickness={5}
          size={matchesxs ? 60 : 80}
        />
        <Box
          sx={{
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            position: 'absolute',
          }}
        >
          <Typography
            variant="caption"
            component="div"
            sx={{ color: '#000000', ...poppins500, fontSize: '14px' }}
          >
            {props.profileImage == '' || props.profileImage == null ? (
              <Avatar
                style={{
                  fontSize: matchesxs ? '20px' : '30px',
                  width: matchesxs ? '44px' : '62px',
                  height: matchesxs ? '44px' : '62px',
                  backgroundColor: '#666666',
                }}
              >
                {props.name}
              </Avatar>
            ) : (
              <Avatar
                alt={props.name}
                src={props.profileImage}
                style={{
                  width: matchesxs ? '44px' : '62px',
                  height: matchesxs ? '44px' : '62px',
                }}
              />
            )}
          </Typography>
        </Box>
      </Box>
    );
  }

  const [open, setOpen] = useState(false);

  const handleClose = () => {
    setOpen(false);
  };

  const [anchorEl, setAnchorEl] = useState(null);
  const [selectedTime, setSelectedTime] = useState('');
  const [isEditing, setIsEditing] = useState(false);
  const [confirmedTimer, setConfirmedTimer] = useState(st2InitialTimer);

  const initialDisplayValue = confirmedTimer ? `${confirmedTimer} hours` : '';

  const [oldInitialTimer, setOldInitialTimer] = useState(st2InitialTimer);
  const [oldResetTimer, setOldResetTimer] = useState(st2ResetTimer);

  const handleEditClick = (event) => {
    setAnchorEl(event.currentTarget);
    setIsEditing(true);
    // Store old values when opening the popup
    setOldInitialTimer(confirmedTimer);
    setOldResetTimer(st2ResetTimer);
    if (st2ResetTimer !== undefined && st2ResetTimer !== null) {
      const hours = Math.floor(st2ResetTimer / 60);
      const minutes = st2ResetTimer % 60;
      setResetTime(dayjs().hour(hours).minute(minutes).second(0));
    }
  };

  const handleEditClose = () => {
    setAnchorEl(null);
    setSelectedTime('');
    if (st2ResetTimer !== undefined && st2ResetTimer !== null) {
      const hours = Math.floor(st2ResetTimer / 60);
      const minutes = st2ResetTimer % 60;
      setResetTime(dayjs().hour(hours).minute(minutes).second(0));
    }
  };

  const handleConfirmClick = () => {
    const selectedTimeValue = selectedTime
      ? parseInt(selectedTime.split(' ')[0]) * 60
      : confirmedTimer * 60;
    const resetTimerValue = resetTime
      ? resetTime.hour() * 60 + resetTime.minute()
      : st2ResetTimer;

    // Check if reset timer is greater than initial timer
    if (resetTimerValue > selectedTimeValue) {
      setLessthanstage2(true);
      setTimerresetpopup(true);
      return;
    }

    // Check if reset timer is greater than 6 hours
    if (resetTimerValue > 360) {
      setLessthanstage2(false);
      setTimerresetpopup(true);
      return;
    }

    // If no warnings, proceed with confirmation
    if (selectedTime) {
      const newConfirmedTimer = selectedTime.split(' ')[0];
      setConfirmedTimer(newConfirmedTimer);
    }
    setSelectedTime('');

    // const newMinutes = resetTime.hour() * 60 + resetTime.minute();
    const newMinutes = resetTime
      ? resetTime.hour() * 60 + resetTime.minute()
      : st2ResetTimer;
    setSt2ResetTimer(newMinutes);

    setIsChangedSet(
      (selectedTime && selectedTime.split(' ')[0] != st2InitialTimer) ||
        newMinutes != stageData?.stageTwoCondition?.TimerReset
        ? 1
        : 0
    );

    setIsEditing(false);
    handleEditClose();
  };

  const handleTimeChange = (event) => {
    const newValue = event.target.value;
    setSelectedTime(newValue);
    if (newValue) {
      const newInitialTimer = parseInt(newValue.split(' ')[0]) * 60;
      const resetTimerValue = resetTime
        ? resetTime.hour() * 60 + resetTime.minute()
        : st2ResetTimer;

      if (resetTimerValue > newInitialTimer) {
        setLessthanstage2(true);
      } else if (resetTimerValue > 360) {
        setLessthanstage2(false);
      } else {
        setLessthanstage2(false);
      }
    }
  };

  const openEdit = Boolean(anchorEl);
  const id = openEdit ? 'simple-popover' : undefined;

  const [resetTime, setResetTime] = useState(null);

  useEffect(() => {
    if (st2ResetTimer !== undefined) {
      const hours = Math.floor(st2ResetTimer / 60);
      const minutes = st2ResetTimer % 60;
      setResetTime(dayjs().hour(hours).minute(minutes).second(0));
    }
  }, [st2ResetTimer]);

  const [openVendorStatusBox, setOpenVendorStatusBox] = useState(false);
  const [forwardVendorLoading, setForwardVendorLoading] = useState(false);
  const [frdOfferToVendorLoading, setFrdOfferToVendorLoading] = useState(false);
  const [openBox, setOpenBox] = useState(false);
  const [buyerName, setBuyerName] = useState('');
  const [buyerSurName, setBuyerSurName] = useState('');
  const [address, setAddress] = useState('');
  const [offerUniqueId, setOfferUniqueId] = useState('');
  const [offerStatus, setofferStatus] = useState('');
  const [offerPrice, setOfferPrice] = useState('');
  const [offerPriceVendor, setOfferPriceVendor] = useState('');
  const [sharedToMarket, setSharedToMarket] = useState('');

  const handleForwardIconClick = ({
    isFwdToBuyer,
    isFwdToVendor,
    buyerName,
    address,
    offerUniqueId,
    offerStatus,
    buyerSurName,
    offerPrice,
    offerPriceVendor,
    sharedToMarket,
  }) => {
    if (isFwdToBuyer == 1) {
      setOpenVendorStatusBox(true);
      setBuyerName(buyerName);
      setBuyerSurName(buyerSurName);
      setAddress(address);
      setOfferUniqueId(offerUniqueId);
      setofferStatus(offerStatus);
      setOfferPrice(offerPrice);
      setOfferPriceVendor(offerPriceVendor);
      setSharedToMarket(sharedToMarket);
    } else if (isFwdToVendor == 1) {
      setOpenBox(!openBox);
      setBuyerName(buyerName);
      setBuyerSurName(buyerSurName);
      setAddress(address);
      setOfferUniqueId(offerUniqueId);
      setOfferPrice(offerPrice);
    }
  };

  // FIXED: PDF loading states and useEffect
  // Replace your existing PDF loading useEffect (lines 615-643) with this:

  const [loading, setLoading] = useState(false);
  const [fileUrl, setFileUrl] = useState(null); // This will now store ArrayBuffer

  useEffect(() => {
    const loadPdf = async () => {
      if (lowestAcceptedOfferFile && stage2AcceptanceCertificate) {
        setLoading(true);
        try {
          const response = await fetch(lowestAcceptedOfferFile);
          const blob = await response.blob();
          const blobUrl = URL.createObjectURL(blob);

          setFileUrl(blobUrl); // ✅ Viewer supports this
        } catch (error) {
          setFileUrl(null);
        } finally {
          setLoading(false);
        }
      }
    };

    loadPdf();

    return () => {
      if (fileUrl?.startsWith('blob:')) {
        URL.revokeObjectURL(fileUrl);
      }
    };
  }, [lowestAcceptedOfferFile, stage2AcceptanceCertificate]);

  useEffect(() => {
    if (forwardVendorLoading || loaderStage2) {
      document.body.style.pointerEvents = 'none';
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.pointerEvents = 'auto';
      document.body.style.overflow = 'auto';
    }

    return () => {
      document.body.style.pointerEvents = 'auto';
      document.body.style.overflow = 'auto';
    };
  }, [forwardVendorLoading, loaderStage2]);

  const [openStage2Popup, setOpenStage2Popup] = useState(false);
  const [blockedBuyerId, setBlockedBuyerId] = useState(null);
  const unhandledSectionRef = useRef(null);

  const handleStage2PopupOpen = (buyerId) => {
    setBlockedBuyerId(buyerId);
    setOpenStage2Popup(true);
  };

  const handleStage2PopupClose = () => {
    setOpenStage2Popup(false);

    setTimeout(() => {
      if (unhandledSectionRef.current) {
        unhandledSectionRef.current.scrollIntoView({
          behavior: 'smooth',
          block: 'center',
        });
      }
    }, 300);
  };

  useEffect(() => {
    if (openCommenceStageTwo) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'auto';
    }

    return () => {
      document.body.style.overflow = 'auto';
    };
  }, [openCommenceStageTwo]);

  const handleTimerResetCancel = () => {
    if (st2ResetTimer !== undefined && st2ResetTimer !== null) {
      const hours = Math.floor(st2ResetTimer / 60);
      const minutes = st2ResetTimer % 60;
      const restoredResetTime = dayjs().hour(hours).minute(minutes).second(0);
      setResetTime(restoredResetTime);
      setTimer(restoredResetTime);
      setTimerreset(st2ResetTimer);
    }
    setSelectedTime('');
    setTimerresetpopup(false);
  };

  // Handle timer reset confirm for >6 hours warning
  const handleTimerResetConfirm = () => {
    if (selectedTime) {
      const newConfirmedTimer = selectedTime.split(' ')[0];
      setConfirmedTimer(newConfirmedTimer);
    }

    const newMinutes = resetTime
      ? resetTime.hour() * 60 + resetTime.minute()
      : st2ResetTimer;
    setSt2ResetTimer(newMinutes);

    setIsChangedSet(
      (selectedTime && selectedTime.split(' ')[0] != st2InitialTimer) ||
        newMinutes != stageData?.stageTwoCondition?.TimerReset
        ? 1
        : 0
    );

    setIsEditing(false);
    handleEditClose();
    setTimerresetpopup(false);
  };

  return (
    <React.Fragment>
      <Dialog
        open={openCommenceStageTwo}
        onClose={onCloseCommenceStageTwo}
        disablePortal
        PaperProps={{
          sx: {
            zIndex: 10,
            borderRadius: '5px',
            minWidth: {
              xs: '100%',
              sm: '100%',
              md: '100%',
              lg: '1060px',
              xl: '1060px',
            },
            boxShadow: ' -4px, 4px rgba(0, 0, 0, 0.09)',
            padding: '30px',
            paddingBottom: matches700 ? '70px' : '20px',
            transform: 'none',
            maxHeight: '100%',
          },
        }}
        sx={{
          zIndex: 10,
          '& .MuiDialog-container': {
            alignItems: 'flex-start',
            pt: ' 13vh',
          },
        }}
      >
        <Grid
          container
          sx={{
            display: 'flex',
            flexDirection: 'column',
          }}
        >
          <Grid item xs={12}>
            <Typography
              sx={{ ...poppins400, fontSize: '14px', color: '#666666' }}
            >
              {stageData?.PropertyDetails?.propertyAddress?.streetName} &nbsp;
            </Typography>
          </Grid>

          <Grid
            item
            xs={12}
            display={'flex'}
            alignItems={'center'}
            padding={'12px 0px 15px 0'}
          >
            <Pendingwarning />
            <Typography
              sx={{
                ...poppins500,
                fontSize: matchesxs ? '20px' : '24px',
                paddingLeft: '12px',
              }}
            >
              Commence Stage 2
            </Typography>
          </Grid>

          <Grid item xs={12}>
            <Typography
              sx={{ ...poppins400, fontSize: '16px', color: '#666666' }}
            >
              Please confirm the below Stage 2 options.
            </Typography>
          </Grid>

          <Grid item xs={12}>
            <Divider sx={{ ml: '-30px', mr: '-30px', mt: '30px' }} />
          </Grid>

          <Grid
            item
            container
            xs={12}
            sx={{
              display: 'flex',
              flexDirection: 'row',
              border: '1px solid',
              borderColor: 'var(--Colors-Green, #34C759)',
              padding: 2,
              mt: '40px',
              alignItems: 'center',
              mr: '-30px',
              gap: '10px',
              justifyContent: matchessm && 'center',
            }}
          >
            <Grid>
              <WarningIcon fontSize={isXsScreen ? 'small' : 'medium'} />
            </Grid>
            <Grid>
              <Typography
                sx={{ ...poppins400, color: '#666666', fontSize: '16px' }}
              >
                Accepted Offer :
              </Typography>
            </Grid>
            <Grid>
              <Typography
                sx={{ ...poppins400, color: '#000000', fontSize: '16px' }}
              >
                {lowestAcceptedOffer}
              </Typography>
            </Grid>
            <Grid>
              <Typography
                sx={{
                  display: 'flex',
                  width: '95px',
                  padding: '3px 6px',
                  alignItems: 'flex-start',
                  justifyContent: 'center',
                  gap: '10px',
                  borderRadius: '5px',
                  background:
                    lowestAcceptedOfferIsConditional == 1
                      ? 'rgba(237, 11, 11, 0.60)'
                      : '#10D35E',
                  marginTop: '-2px',
                }}
              >
                <Typography
                  sx={{
                    color: '#FFF',
                    fontFamily: 'Poppins',
                    fontSize: '10px',
                    fontStyle: 'normal',
                    fontWeight: 500,
                    lineHeight: 'normal',
                    textTransform: 'capitalize',
                  }}
                >
                  {lowestAcceptedOfferIsConditional == 1
                    ? 'Conditional'
                    : 'Unconditional'}
                </Typography>
              </Typography>
            </Grid>
            {lowestAcceptedOfferFile ? (
              <Grid
                onClick={() => {
                  setStage2AcceptanceCertificate(true);
                }}
                sx={{ cursor: 'pointer' }}
              >
                <Typography
                  sx={{ ...poppins400, color: '#6C2AD2', fontSize: '16px' }}
                >
                  View Acceptance Certificate
                </Typography>
              </Grid>
            ) : null}
          </Grid>

          <Grid item textAlign={'left'} paddingTop={'30px'}>
            <Typography
              sx={{
                ...poppins400,
                fontSize: matchesxs ? '18px' : '24px',
                color: '#000000',
              }}
              whiteSpace={'nowrap'}
            >
              retreX Campaign Configuration
            </Typography>
          </Grid>
          <Grid
            item
            container
            xs={12}
            sx={{
              display: 'flex',
              flexDirection: 'row',
              mt: '30px',
              alignItems: 'center',
              mr: '-30px',
              gap: '40px',
            }}
          >
            <Grid>
              <Typography
                sx={{ ...poppins400, color: '#666666', fontSize: '16px' }}
              >
                Stage 2 Offers
              </Typography>
            </Grid>
            <Grid sx={{ alignItems: 'center' }}>
              <Stack
                direction="row"
                alignItems="center"
                spacing={2}
                sx={{ gap: '5px' }}
              >
                <Typography
                  sx={{
                    ...poppins400,
                    fontSize: '16px',
                    color: conditionType ? '#9C9C9C' : '#112347',
                  }}
                >
                  All
                </Typography>

                <Box
                  onClick={() => {
                    handleToggle();
                  }}
                  sx={{
                    width: 40,
                    height: 24,
                    borderRadius: 999,
                    backgroundColor: '#1976d2',
                    position: 'relative',
                    cursor: 'pointer',
                    transition: 'background-color 0.3s',
                  }}
                >
                  <Box
                    sx={{
                      width: 16,
                      height: 16,
                      borderRadius: '50%',
                      backgroundColor: '#fff',
                      position: 'absolute',
                      top: '50%',
                      left: conditionType ? '22px' : '2px',
                      transform: 'translateY(-50%)',
                      transition: 'left 0.3s',
                    }}
                  />
                </Box>

                <Typography
                  sx={{
                    ...poppins400,
                    fontSize: '16px',
                    color: conditionType ? '#112347' : '#9C9C9C',
                  }}
                >
                  Unconditional only
                </Typography>
              </Stack>
            </Grid>
          </Grid>
          <Grid item textAlign={'left'} paddingTop={'30px'}>
            <Typography
              sx={{ ...poppins400, fontSize: '16px', color: '#666666' }}
              whiteSpace={'nowrap'}
            >
              Stage 2 Timer Setup
            </Typography>
          </Grid>
          <Grid
            item
            container
            xs={12}
            sx={{
              display: 'flex',
              flexDirection: 'row',
              mt: '30px',
              alignItems: 'center',
              mr: '-30px',
              gap: '40px',
            }}
          >
            <Grid
              sx={{
                width: '149px',
                height: '117px',
                border: '1px solid',
                borderColor: 'var(--Colors-Blue, rgba(0, 122, 255, 1))',
                backgroundColor: 'rgba(0, 122, 255, 0.2)',
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
                alignItems: 'center',
                gap: '15px',
                position: 'relative',
                borderRadius: '8px',
              }}
            >
              <div
                style={{
                  position: 'absolute',
                  top: '5px',
                  right: '5px',
                  cursor: 'pointer',
                }}
                onClick={handleEditClick}
              >
                <Edit />
              </div>
              <Typography
                sx={{
                  fontSize: '32px',
                  color: 'var(--Colors-Blue, rgba(0, 122, 255, 1))',
                  fontFamily: 'Poppins',
                  fontWeight: 500,
                  alignItems: 'center',
                  padding: '8px',
                }}
              >
                {/* {st2InitialTimer} */}
                {confirmedTimer}
                <span
                  style={{
                    fontSize: '16px',
                  }}
                >
                  hrs
                </span>
              </Typography>
              <Typography
                sx={{
                  fontSize: '16px',
                  color: 'var(--Colors-Blue, rgba(0, 122, 255, 1))',
                  fontFamily: 'Poppins',
                  fontWeight: 300,
                  alignItems: 'center',
                }}
              >
                Initial Timer
              </Typography>
            </Grid>
            <Grid
              sx={{
                width: '149px',
                height: '117px',
                border: '1px solid',
                borderColor: 'var(--Colors-Blue, rgba(0, 122, 255, 1))',
                backgroundColor: 'rgba(0, 122, 255, 0.2)',
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
                alignItems: 'center',
                gap: '15px',
                position: 'relative',
                borderRadius: '8px',
              }}
            >
              <div
                style={{
                  position: 'absolute',
                  top: '5px',
                  right: '5px',
                  cursor: 'pointer',
                }}
                onClick={handleEditClick}
              >
                <Edit />
              </div>
              <Typography
                sx={{
                  fontSize:
                    Math.floor(st2ResetTimer / 60) > 0 && st2ResetTimer % 60 > 0
                      ? '23px'
                      : '32px',
                  color: 'var(--Colors-Blue, rgba(0, 122, 255, 1))',
                  fontFamily: 'Poppins',
                  fontWeight: 500,
                  alignItems: 'center',
                  padding: '8px',
                }}
              >
                {Math.floor(st2ResetTimer / 60) > 0 && (
                  <>
                    {Math.floor(st2ResetTimer / 60)}
                    <span style={{ fontSize: '16px' }}>hrs</span>
                  </>
                )}
                {st2ResetTimer % 60 > 0 && (
                  <>
                    {Math.floor(st2ResetTimer / 60) > 0 && ' '}
                    {st2ResetTimer % 60}
                    <span style={{ fontSize: '16px' }}>mins</span>
                  </>
                )}
              </Typography>
              <Typography
                sx={{
                  fontSize: '16px',
                  color: 'var(--Colors-Blue, rgba(0, 122, 255, 1))',
                  fontFamily: 'Poppins',
                  fontWeight: 300,
                  alignItems: 'center',
                }}
              >
                Reset Timer
              </Typography>
            </Grid>
          </Grid>
          <Popover
            id={id}
            open={openEdit}
            anchorEl={anchorEl}
            onClose={handleEditClose}
            anchorReference="anchorPosition"
            anchorPosition={{
              top: window.innerHeight / 2,
              left: window.innerWidth / 2,
            }}
            anchorOrigin={{
              vertical: 'center',
              horizontal: 'center',
            }}
            transformOrigin={{
              vertical: 'center',
              horizontal: 'center',
            }}
            sx={{
              padding: '20px',
              paddingBottom: matches700 && '70px',
              width: matchesxs ? '100%' : 'auto',
            }}
          >
            <Grid
              container
              sm={12}
              display={'flex'}
              alignItems={'center'}
              padding={2}
            >
              <Pendingwarning />
              <Typography
                sx={{
                  ...poppins500,
                  fontSize: matchesxs ? '20px' : '24px',
                  paddingLeft: '12px',
                }}
              >
                Stage 2 Timer Setup
              </Typography>
            </Grid>
            <Grid
              container
              sm={12}
              xs={12}
              lg={12}
              sx={{ display: 'flex', flexDirection: 'row' }}
            >
              <Grid
                item
                sm={4}
                xs={6}
                lg={6}
                sx={{
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: 'center',
                  padding: 2,
                  justifyContent: 'space-around',
                  gap: '15px',
                }}
              >
                <Grid item>
                  <Typography
                    sx={{
                      ...poppins500,
                      fontSize: matchesxs ? '14px' : '16px',
                      color: '#666666',
                    }}
                  >
                    Initial timer for Stage 2
                  </Typography>
                </Grid>
                <Grid item>
                  <Typography
                    sx={{
                      ...poppins500,
                      fontSize: matchesxs ? '14px' : '16px',
                      color: '#666666',
                    }}
                  >
                    Reset timer for Stage 2
                  </Typography>
                </Grid>
              </Grid>
              <Grid
                item
                sm={6}
                xs={6}
                lg={6}
                sx={{
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: 'center',
                  padding: 2,
                  justifyContent: 'space-around',
                  gap: '15px',
                }}
              >
                <Grid item>
                  <FormControl>
                    <Select
                      value={selectedTime}
                      onChange={handleTimeChange}
                      displayEmpty
                      renderValue={(value) => {
                        if (!value) return initialDisplayValue;
                        return value;
                      }}
                      inputProps={{
                        'aria-label': 'Without label',
                        sx: {
                          ...poppins400,
                          fontSize: matchesxs ? '12px' : '16px',
                          color: '#666666',
                        },
                      }}
                      sx={{
                        height: '56px',
                        width: matchesxs ? '37vw' : '220px',
                        '& .MuiInputBase-input': {
                          ...poppins400,
                          fontSize: '16px',
                          color: '#666666',
                          padding: '8px',
                          height: '56px',
                          display: 'flex',
                          alignItems: 'center',
                        },
                        '& .MuiSelect-icon': {
                          minHeight: '40px',
                          top: 'calc(50% - 20px)',
                        },
                      }}
                    >
                      <MenuItem
                        value="4 hours"
                        sx={{
                          ...poppins400,
                          fontSize: matchesxs ? '12px' : '16px',
                          color: '#666666',
                        }}
                      >
                        4 hours
                      </MenuItem>
                      <MenuItem
                        value="6 hours"
                        sx={{
                          ...poppins400,
                          fontSize: matchesxs ? '12px' : '16px',
                          color: '#666666',
                        }}
                      >
                        6 hours
                      </MenuItem>
                      <MenuItem
                        value="24 hours"
                        sx={{
                          ...poppins400,
                          fontSize: matchesxs ? '12px' : '16px',
                          color: '#666666',
                        }}
                      >
                        24 hours
                      </MenuItem>
                    </Select>
                  </FormControl>
                </Grid>
                <Grid item>
                  <LocalizationProvider dateAdapter={AdapterDayjs}>
                    <TimePicker
                      value={resetTime}
                      onChange={(newValue) => setResetTime(newValue)}
                      onAccept={(newValue) => {
                        if (newValue) {
                          let val = moment(new Date(newValue)).format('HH:mm');
                          const [hours, minutes] = val.split(':').map(Number);
                          const totalMinutes = hours * 60 + minutes;

                          setTimer(newValue);
                          setTimerreset(totalMinutes);

                          let selectedTimeMinutes = 0;
                          if (selectedTime) {
                            if (selectedTime.includes('hour')) {
                              selectedTimeMinutes = parseInt(selectedTime) * 60;
                            } else if (selectedTime.includes('minute')) {
                              selectedTimeMinutes = parseInt(selectedTime);
                            }
                          }

                          if (
                            selectedTimeMinutes &&
                            totalMinutes > selectedTimeMinutes
                          ) {
                            // setTimerresetpopup(true);
                            setLessthanstage2(true);
                          } else if (totalMinutes > 360) {
                            // setTimerresetpopup(true);
                            setLessthanstage2(false);
                          } else {
                            // setTimerresetpopup(false);
                            setLessthanstage2(false);
                          }
                        } else {
                          setTimer(null);
                          setTimerreset(30);
                        }
                      }}
                      ampm={false}
                      sx={pick_date}
                      slotProps={{
                        textField: {
                          sx: {
                            width: matchesxs ? '37vw' : '220px',

                            '& .MuiOutlinedInput-root': {
                              height: '56px',
                            },

                            '& .MuiInputBase-input': {
                              padding: '16.5px 14px',
                              textAlign: 'left',
                              width: '100%',
                              boxSizing: 'border-box',
                            },
                          },
                        },
                      }}
                    />
                  </LocalizationProvider>
                </Grid>
              </Grid>
            </Grid>
            <Grid
              container
              xs={12}
              direction="row"
              justifyContent={matchessm ? 'center' : 'flex-end'}
              gap={2}
              padding={2}
              style={{ width: '100%' }}
            >
              <Grid item xs={3}>
                <Button
                  variant="outlined"
                  style={{
                    padding: '10px 39px',
                    width: '100%',
                    height: '41px',
                    fontSize: '14px',
                    fontWeight: '400',
                    fontFamily: 'Poppins',
                    borderRadius: '5px',
                    textTransform: 'none',
                    cursor: 'pointer',
                  }}
                  onClick={handleEditClose}
                >
                  Close
                </Button>
              </Grid>
              <Grid item xs={3}>
                <Button
                  variant="contained"
                  style={{
                    padding: '10px 39px',
                    width: '100%',
                    height: '41px',
                    fontSize: '14px',
                    color: '#FFFFFF',
                    fontWeight: '400',
                    fontFamily: 'Poppins',
                    background: '#4CA4D6',
                    borderRadius: '5px',
                    textTransform: 'none',
                    cursor: 'pointer',
                  }}
                  onClick={handleConfirmClick}
                >
                  Confirm
                </Button>
              </Grid>
            </Grid>
          </Popover>
          {unhandledOffersCount != 0 && (
            <Grid item textAlign={'left'} paddingTop={'30px'}>
              <Typography
                sx={{ ...poppins400, fontSize: '24px', color: '#000000' }}
                whiteSpace={'nowrap'}
              >
                Unhandled Offers
              </Typography>
            </Grid>
          )}
          {unhandledOffersCount != 0 && (
            <Grid
              item
              container
              xs={12}
              sx={{
                display: 'flex',
                flexDirection: 'row',
                border: '1px solid',
                borderColor: '#FF3830',
                backgroundColor: '#F939391A',
                padding: 2,
                mt: '30px',
                alignItems: 'center',
                mr: '-30px',
                gap: '30px',
              }}
            >
              <Grid>
                <Typography
                  sx={{
                    ...poppins400,
                    color: '#666666',
                    fontSize: '16px',
                    whiteSpace: 'normal',
                    wordWrap: 'break-word',
                    display: 'flex',
                    gap: 2,
                    alignItems: 'center',
                  }}
                >
                  <WarningIconRED fontSize={isXsScreen ? 'small' : 'medium'} />{' '}
                  {''} Warning! You currently have{' '}
                  <Box
                    component="span"
                    sx={{ ...poppins700, fontSize: '16px', mx: -1 }}
                  >
                    {unhandledOffersCount}{' '}
                  </Box>
                  unhandled offers. Please handle these offers prior to
                  commencing Stage 2.
                </Typography>
              </Grid>
            </Grid>
          )}
          <Grid
            container
            alignItems="center"
            sx={{ position: 'relative', width: '100%', mt: '20px' }}
          >
            {showChevrons && (
              <IconButton
                onClick={scrollLeft}
                disabled={isAtStart}
                sx={{
                  position: 'absolute',
                  left: 0,
                  zIndex: 2,
                  background: '#FFF',
                  boxShadow: 2,
                  cursor: isAtStart ? 'not-allowed' : 'pointer',
                  opacity: isAtStart ? 0.4 : 1,
                }}
              >
                <ChevronLeft />
              </IconButton>
            )}
            <Box
              sx={{
                width: '930px',
                margin: '0 auto',
                overflow: 'hidden',
              }}
            >
              <Grid
                item
                container
                ref={sliderRef}
                sx={{
                  overflowX: 'hidden',
                  flexWrap: 'nowrap',
                  display: 'flex',
                  gap: '10px',
                  scrollBehavior: 'smooth',
                }}
              >
                {filteredBuyers?.map((item, index) => {
                  const isFwdToBuyer = item?.buyerOfferDetails?.isFwdToBuyer2;
                  const isFwdToVendor = item?.buyerOfferDetails?.isFwdToVendor;
                  const buyerName = item?.buyerDetails?.user?.userName;
                  const buyerSurName = item?.buyerDetails?.user?.userSurName;
                  const address =
                    stageData?.PropertyDetails?.propertyAddress?.streetName;
                  const offerUniqueId = item?.buyerOfferDetails?.offerUniqueId;
                  const offerStatus = item?.buyerOfferDetails?.offerStatus;
                  const offerStatusVendor =
                    item?.buyerOfferDetails?.offerStatusVendor;
                  const offerPrice = item?.buyerOfferDetails?.offerPrice;
                  const offerPriceVendor =
                    item?.buyerOfferDetails?.offerPriceVendor;
                  const sharedToMarket = item?.buyerOfferDetails?.isMarket;

                  const badgeOfferStatus =
                    item?.buyerOfferDetails?.isNew == 1
                      ? offerStatus
                      : item?.buyerOfferDetails?.isNew == 0 &&
                        item?.buyerOfferDetails?.offerStatusVendor ==
                          'Vendor Notified'
                      ? offerStatusVendor
                      : offerStatus;

                  return (
                    <Grid
                      key={index}
                      data-index={index}
                      sx={{
                        minWidth: '460px',
                        maxWidth: '460px',
                        flexShrink: 0,
                        height: '196px',
                        border: '0.5px solid #FAFAFA',
                        backgroundColor: '#FAFAFA',
                        display: 'flex',
                        flexDirection: 'row',
                        justifyContent: 'space-between',
                        gap: '5px',
                        borderRadius: '10px',
                        padding: matchesxs ? '5px' : '20px',
                      }}
                    >
                      <Grid
                        item
                        xs={3}
                        sx={{ display: 'flex', alignItems: 'center' }}
                      >
                        {item?.buyerDetails?.user?.userProfile == '' ||
                        item?.buyerDetails?.user?.userProfile == null ? (
                          <Box
                            sx={{
                              position: 'relative',
                              display: 'inline-flex',
                            }}
                          >
                            <CircularProgress
                              variant="determinate"
                              value={100}
                              sx={{ color: '#C4C4C461' }}
                              thickness={5}
                              size={matchesxs ? 60 : 80}
                            />
                            <CircularProgress
                              variant="determinate"
                              value={item?.buyerDetails?.profileActivity}
                              sx={{ color: '#10D35E', position: 'absolute' }}
                              thickness={5}
                              size={matchesxs ? 60 : 80}
                            />
                            <Box
                              sx={{
                                top: '50%',
                                left: '50%',
                                transform: 'translate(-50%, -50%)',
                                position: 'absolute',
                              }}
                            >
                              <Typography
                                variant="caption"
                                component="div"
                                sx={{
                                  color: '#000000',
                                  ...poppins500,
                                  fontSize: '14px',
                                }}
                              >
                                <Avatar
                                  style={{
                                    fontFamily: 'poppins',
                                    fontSize: matchesxs ? '18px' : '30px',
                                    width: matchesxs ? '44px' : '62px',
                                    height: matchesxs ? '44px' : '62px',
                                    backgroundColor: '#666666',
                                  }}
                                >
                                  {item?.buyerDetails?.user?.userName
                                    ?.charAt(0)
                                    ?.toUpperCase()}
                                  {item?.buyerDetails?.user?.userSurName
                                    ?.charAt(0)
                                    ?.toUpperCase()}
                                </Avatar>
                              </Typography>
                            </Box>
                          </Box>
                        ) : (
                          <CircularProgressWithProfile
                            name={
                              item?.buyerDetails?.user?.userName

                                .charAt(0)

                                ?.toUpperCase() +
                              item?.buyerDetails?.user?.userSurName

                                .charAt(0)

                                ?.toUpperCase()
                            }
                            data={item?.buyerDetails?.profileActivity}
                            profileImage={item?.buyerDetails?.user?.userProfile}
                            sx={{ width: matchesxs ? '100%' : 'auto' }}
                          />
                        )}
                      </Grid>
                      <Grid
                        item
                        xs={3}
                        sx={{
                          display: 'flex',
                          alignItems: 'flex-start',
                          flexDirection: 'column',
                          justifyContent: 'space-between',
                        }}
                      >
                        <Grid>
                          <Typography
                            sx={{
                              ...poppins500,
                              fontSize: matchesxs ? '12px' : '14px',
                              color: '#26344E',
                            }}
                          >
                            Buyer :{' '}
                          </Typography>
                        </Grid>
                        <Grid>
                          <Typography
                            sx={{
                              ...poppins500,
                              fontSize: matchesxs ? '12px' : '14px',
                              color: '#26344E',
                            }}
                          >
                            Offer :{' '}
                          </Typography>
                        </Grid>
                        <Grid>
                          <Typography
                            sx={{
                              ...poppins500,
                              fontSize: matchesxs ? '12px' : '14px',
                              color: '#26344E',
                            }}
                          >
                            Offer Terms :{' '}
                          </Typography>
                        </Grid>
                        <Grid>
                          <Typography
                            sx={{
                              ...poppins500,
                              fontSize: matchesxs ? '12px' : '14px',
                              color: '#26344E',
                            }}
                          >
                            Status :{' '}
                          </Typography>
                        </Grid>
                      </Grid>
                      <Grid
                        item
                        xs={4.5}
                        sx={{
                          display: 'flex',
                          alignItems: 'flex-start',
                          flexDirection: 'column',
                          justifyContent: 'space-between',
                          minWidth: 0,
                          overflow: 'hidden',
                        }}
                      >
                        <Grid sx={{ width: '100%', minWidth: 0 }}>
                          <NameTooltip
                            name={item?.buyerDetails?.user?.userName}
                            surname={item?.buyerDetails?.user?.userSurName}
                          >
                            <Typography
                              sx={{
                                ...poppins400,
                                fontSize: matchesxs ? '12px' : '16px',
                                color: '#666666',
                                width: '100%',
                                whiteSpace: 'nowrap',
                                overflow: 'hidden',
                                textOverflow: 'ellipsis',
                                display: 'block',
                                cursor: 'pointer',
                              }}
                            >
                              {item?.buyerDetails?.user?.userName}{' '}
                              {item?.buyerDetails?.user?.userSurName}
                            </Typography>
                          </NameTooltip>
                        </Grid>
                        <Grid>
                          <Typography
                            sx={{
                              ...poppins500,
                              fontSize: matchesxs ? '12px' : '14px',
                              color: '#26344E',
                            }}
                          >
                            {item?.buyerOfferDetails?.offerPrice}{' '}
                          </Typography>
                        </Grid>
                        <Grid>
                          {' '}
                          <Typography
                            sx={{
                              display: 'flex',
                              width: '95px',
                              padding: '3px 6px',
                              alignItems: 'flex-start',
                              justifyContent: 'center',
                              gap: '10px',
                              borderRadius: '5px',
                              background:
                                item?.buyerDetails == null
                                  ? '#FFF'
                                  : item?.buyerDetails?.buyerOffer
                                      ?.logIsConditional == 1
                                  ? 'rgba(237, 11, 11, 0.60)'
                                  : '#10D35E',
                              marginTop: '-2px',
                            }}
                          >
                            <Typography
                              sx={{
                                color: item?.buyerDetails == null ? '' : '#FFF',
                                fontFamily: 'Poppins',
                                fontSize:
                                  item?.buyerDetails == null ? '16px' : '10px',
                                fontStyle: 'normal',
                                fontWeight: 500,
                                lineHeight: 'normal',
                                textTransform: 'capitalize',
                              }}
                            >
                              {item?.buyerDetails == null
                                ? '-'
                                : item?.buyerDetails?.buyerOffer
                                    ?.logIsConditional == 1
                                ? 'Conditional'
                                : 'Unconditional'}
                            </Typography>
                          </Typography>
                        </Grid>
                        <Grid>
                          <BadgeButton
                            offerStatus={badgeOfferStatus}
                            matchesxs={matchesxs}
                            isnew={item?.buyerOfferDetails?.isNew}
                          />
                        </Grid>
                      </Grid>
                      <Grid
                        item
                        xs={1.5}
                        sx={{
                          display: 'flex',
                          alignItems: 'center',
                          flexDirection: 'column',
                          justifyContent: 'center',
                          gap: '100px',
                        }}
                      >
                        <Grid
                          item
                          sx={{
                            display: 'flex',
                            alignItems: 'center',
                            flexDirection: 'column',
                            justifyContent: 'center',
                          }}
                        >
                          <Grid>
                            {' '}
                            <Exclamatory matchesxs={matchesxs} />{' '}
                          </Grid>
                          <Grid>
                            {' '}
                            <Typography
                              sx={{
                                ...poppins300,
                                fontSize: matchesxs ? '8px' : '12px',
                                color: '#666666',
                              }}
                            >
                              {' '}
                              Required{' '}
                            </Typography>
                          </Grid>
                        </Grid>
                        <Grid
                          item
                          sx={{ alignSelf: 'flex-end', mb: '-10px' }}
                          onClick={() => {
                            if (isInactive) return;

                            handleForwardIconClick({
                              isFwdToBuyer,
                              isFwdToVendor,
                              buyerName,
                              address,
                              offerUniqueId,
                              offerStatus,
                              buyerSurName,
                              offerPrice,
                              offerPriceVendor,
                              sharedToMarket,
                            });
                          }}
                          style={{
                            cursor: isInactive
                              ? 'not-allowed'
                              : isFwdToBuyer == 1 || isFwdToVendor == 1
                              ? 'pointer'
                              : 'not-allowed',
                          }}
                        >
                          <ForwardOff color={isInactive} />
                        </Grid>
                      </Grid>
                    </Grid>
                  );
                })}
                {isOdd && (
                  <Grid
                    sx={{
                      minWidth: '460px',
                      maxWidth: '460px',
                      flexShrink: 0,
                      visibility: 'hidden',
                    }}
                  />
                )}
              </Grid>
            </Box>
            {showChevrons && (
              <IconButton
                onClick={scrollRight}
                disabled={isAtEnd}
                sx={{
                  position: 'absolute',
                  right: 0,
                  zIndex: 2,
                  background: '#FFF',
                  boxShadow: 2,
                  cursor: isAtEnd ? 'not-allowed' : 'pointer',
                  opacity: isAtEnd ? 0.4 : 1,
                }}
              >
                <ChevronRight />
              </IconButton>
            )}
          </Grid>
          {unhandledOffersCount != 0 && (
            <Grid item textAlign={'left'} paddingTop={'30px'}>
              <Typography
                sx={{ ...poppins400, fontSize: '16px', color: '#529AEE' }}
              >
                <Box component="span" sx={{ ...poppins700, fontSize: '16px' }}>
                  Note:
                </Box>{' '}
                Once the offers above has been handled, the buyers will then be
                available in the list below.
              </Typography>
            </Grid>
          )}

          <Grid item xs={12} textAlign={'left'} paddingTop={'30px'}>
            <Typography
              sx={{ ...poppins400, fontSize: '24px', color: '#000000' }}
            >
              Add Buyers to Stage 2
            </Typography>
          </Grid>
          <Grid item xs={12} textAlign={'left'} paddingTop={'20px'}>
            <Typography
              sx={{ ...poppins400, fontSize: '16px', color: '#666666' }}
            >
              Please select the buyers you would like to participate in Stage 2.
            </Typography>
          </Grid>
          <Grid
            item
            xs={12}
            paddingTop={'30px'}
            width={'100%'}
            sx={{ overflowX: 'scroll !important' }}
          >
            <EnhancedTable
              buyeroffer={false}
              headCells={[
                {
                  id: 'name',
                  numeric: false,
                  disablePadding: true,
                  label: 'Name',
                },
                {
                  id: 'contact',
                  numeric: true,
                  disablePadding: false,
                  label: 'Contact',
                },
                {
                  id: 'buyerreadlines',
                  numeric: true,
                  disablePadding: false,
                  label: 'Buyer Readlines',
                },
                {
                  id: 'status',
                  numeric: true,
                  disablePadding: false,
                  label: 'Status',
                },
                {
                  id: 'offer',
                  numeric: true,
                  disablePadding: false,
                  label: 'Offer',
                },
                {
                  id: 'noofoffer',
                  numeric: true,
                  disablePadding: false,
                  label: 'Number of offers',
                },
                {
                  id: 'propertyrating',
                  numeric: true,
                  disablePadding: false,
                  label: 'Property Rating',
                },
                {
                  id: 'exp',
                  numeric: true,
                  disablePadding: false,
                  label: 'Exp',
                },
                {
                  id: 'profile',
                  numeric: true,
                  disablePadding: false,
                  label: 'Profile',
                },
                {
                  id: 'profile',
                  numeric: true,
                  disablePadding: false,
                  label: '',
                },
                {
                  id: 'action',
                  numeric: true,
                  disablePadding: false,
                  label: 'Action Required',
                },
              ]}
              tableData={rowsWithFlag}
              onClick={props.onClick}
              id={props.id}
              vendorstatustable={true}
              StageTwo={true}
              setForwardOfferCheckList={setForwardOfferCheckList}
              forwardOfferCheckList={forwardOfferCheckList}
              conditionToggle={conditionType ? '1' : '0'}
              directcomm={directcomm}
              onShowChat={onShowChat}
              handleStage2PopupOpen={handleStage2PopupOpen}
              getListInfo={getListInfo}
            />
          </Grid>
          <Grid
            item
            container
            direction="row"
            justifyContent={matchessm ? 'center' : 'flex-end'}
            gap={2}
            marginBottom={3}
          >
            <Grid item>
              <Button
                disabled={loader}
                variant="outlined"
                style={{
                  padding: '10px 39px',
                  width: matchessm ? '170px' : '100%',
                  height: '41px',
                  fontSize: '14px',
                  color: '#666666',
                  fontWeight: '400',
                  fontFamily: 'Poppins',
                  border: '1px solid rgba(17, 35, 71, 0.1)',
                  borderRadius: '5px',
                  textTransform: 'none',
                }}
                onClick={handleStage2CancelClick}
              >
                Cancel
              </Button>
            </Grid>
            <Grid
              item
              sx={{
                cursor:
                  forwardOfferCheckList?.length == 0
                    ? 'not-allowed'
                    : 'pointer',
              }}
            >
              <Button
                variant="outlined"
                disabled={
                  stageData?.PropertyDetails?.timerStatus === 'End' ||
                  forwardOfferCheckList?.length == 0
                }
                onClick={() => {
                  setOpen(true);
                }}
                style={{
                  padding: '10px 39px',
                  width: '100%',
                  height: '41px',
                  fontSize: '14px',
                  color:
                    stageData?.PropertyDetails?.timerStatus === 'End' ||
                    forwardOfferCheckList?.length == 0
                      ? '#C4C4C4'
                      : '#FFFFFF',
                  fontWeight: '400',
                  fontFamily: 'Poppins',
                  background: '#4CA4D6',
                  borderRadius: '5px',
                  textTransform: 'none',
                }}
              >
                Commence
              </Button>
            </Grid>
          </Grid>
        </Grid>
      </Dialog>

      <Dialog
        open={open}
        aria-labelledby="responsive-dialog-title"
        PaperProps={{
          sx: {
            borderRadius: '5px',
            minWidth: matches700 ? '100%' : '721px',
            boxShadow: ' -4px, 4px rgba(0, 0, 0, 0.09)',
            padding: '30px',
            paddingBottom: matches700 ? '90px' : '',
          },
        }}
      >
        <Grid container height={'100%'}>
          <Grid item xs={12}>
            <Typography
              sx={{ ...poppins400, fontSize: '14px', color: '#666666' }}
            >
              {stageData?.PropertyDetails?.propertyAddress?.streetName} &nbsp;
            </Typography>
          </Grid>

          <Grid
            item
            xs={12}
            display={'flex'}
            alignItems={'center'}
            padding={'12px 0px 15px 0'}
          >
            <Pendingwarning />
            <Typography
              sx={{
                ...poppins500,
                fontSize: matchesxs ? '20px' : '24px',
                paddingLeft: '12px',
              }}
            >
              Commence Stage 2
            </Typography>
          </Grid>

          <Grid item xs={12}>
            <Typography
              sx={{ ...poppins400, fontSize: '16px', color: '#666666' }}
            >
              You are about to commence Stage 2.
            </Typography>
          </Grid>

          <Grid
            item
            container
            xs={12}
            sx={{
              display: 'flex',
              flexDirection: 'row',
              mt: '40px',
              ml: !matches700 && '50px',
              gap: matches700 ? '5px' : '20px',
            }}
          >
            <Grid>
              <WarningIcon fontSize={isXsScreen ? 'small' : 'medium'} />
            </Grid>
            <Grid>
              <Typography
                sx={{ ...poppins400, color: '#666666', fontSize: '16px' }}
              >
                Accepted Offer :
              </Typography>
            </Grid>
            <Grid>
              <Typography
                sx={{ ...poppins400, color: '#000000', fontSize: '16px' }}
              >
                {lowestAcceptedOffer}
              </Typography>
            </Grid>
            <Grid>
              <Typography
                sx={{
                  display: 'flex',
                  width: '95px',
                  padding: '3px 6px',
                  alignItems: 'flex-start',
                  justifyContent: 'center',
                  gap: '10px',
                  borderRadius: '5px',
                  background:
                    lowestAcceptedOfferIsConditional == 1
                      ? 'rgba(237, 11, 11, 0.60)'
                      : '#10D35E',
                  marginTop: '-2px',
                }}
              >
                <Typography
                  sx={{
                    color: '#FFF',
                    fontFamily: 'Poppins',
                    fontSize: '10px',
                    fontStyle: 'normal',
                    fontWeight: 500,
                    lineHeight: 'normal',
                    textTransform: 'capitalize',
                  }}
                >
                  {lowestAcceptedOfferIsConditional == 1
                    ? 'Conditional'
                    : 'Unconditional'}
                </Typography>
              </Typography>
            </Grid>
            {lowestAcceptedOfferFile ? (
              <Grid
                onClick={() => {
                  setStage2AcceptanceCertificate(true);
                }}
                sx={{ cursor: 'pointer' }}
              >
                <Typography
                  sx={{ ...poppins400, color: '#6C2AD2', fontSize: '16px' }}
                >
                  View Acceptance Certificate
                </Typography>
              </Grid>
            ) : null}
          </Grid>

          <Grid item xs={12}>
            <Divider sx={{ ml: '-30px', mr: '-30px', mt: '30px' }} />
          </Grid>
          {unhandledOffersCount != 0 && (
            <Grid
              item
              container
              xs={12}
              sx={{
                display: 'flex',
                flexDirection: 'row',
                border: '1px solid',
                borderColor: '#FF3830',
                backgroundColor: '#F939391A',
                padding: 2,
                mt: '30px',
                alignItems: 'center',
              }}
            >
              <Grid
                item
                sx={{
                  display: 'flex',
                  alignItems: 'center',
                  paddingRight: '16px',
                }}
              >
                <WarningIconRED fontSize={isXsScreen ? 'small' : 'medium'} />
              </Grid>
              <Grid item xs>
                <Typography
                  sx={{ ...poppins400, color: '#666666', fontSize: '16px' }}
                >
                  Warning! You currently have{' '}
                  <Box
                    component="span"
                    sx={{ ...poppins700, fontSize: '16px', mx: 0 }}
                  >
                    {unhandledOffersCount}{' '}
                  </Box>
                  unhandled offers. Please handle prior to commencing Stage 2.
                </Typography>
              </Grid>
              <Grid
                item
                xs={1}
                sx={{
                  display: 'flex',
                  alignItems: 'flex-end',
                  justifyContent: 'flex-end',
                  height: '100%',
                  cursor: 'pointer',
                  mb: '-25px',
                }}
                onClick={handleClose}
              >
                <Typography
                  sx={{ ...poppins400, color: '#007AFF', fontSize: '16px' }}
                >
                  View
                </Typography>
              </Grid>
            </Grid>
          )}
          {conditionType && stageData?.isConditionalHigh == 1 && (
            <Grid
              item
              container
              xs={12}
              sx={{
                display: 'flex',
                flexDirection: 'row',
                border: '1px solid',
                borderColor: unhandledOffersCount != 0 ? '#FF3830' : '#FF9500',
                backgroundColor: unhandledOffersCount != 0 ? '#F939391A' : ' ',
                padding: 2,
                mt: '30px',
                alignItems: 'center',
              }}
            >
              <Grid
                item
                sx={{
                  display: 'flex',
                  alignItems: 'center',
                  paddingRight: '16px',
                }}
              >
                {unhandledOffersCount != 0 ? (
                  <WarningIconRED fontSize={isXsScreen ? 'small' : 'medium'} />
                ) : (
                  <WarningIconYELLOW
                    fontSize={isXsScreen ? 'small' : 'medium'}
                  />
                )}
              </Grid>
              <Grid item xs>
                <Typography
                  sx={{ ...poppins400, color: '#666666', fontSize: '16px' }}
                >
                  A conditional offer has been received that is higher than the
                  accepted unconditional offer.
                </Typography>
              </Grid>
              <Grid
                item
                xs={1}
                sx={{
                  display: 'flex',
                  alignItems: 'flex-end',
                  justifyContent: 'flex-end',
                  height: '100%',
                  cursor: 'pointer',
                  mb: '-25px',
                }}
                onClick={handleClose}
              >
                <Typography
                  sx={{ ...poppins400, color: '#007AFF', fontSize: '16px' }}
                >
                  View
                </Typography>
              </Grid>
            </Grid>
          )}
          {stageData?.isSharedMarket == 1 && (
            <Grid
              item
              container
              xs={12}
              sx={{
                display: 'flex',
                flexDirection: 'row',
                border: '1px solid',
                borderColor: '#FF9500',
                padding: 2,
                mt: '30px',
                alignItems: 'center',
              }}
            >
              <Grid
                item
                sx={{
                  display: 'flex',
                  alignItems: 'center',
                  paddingRight: '16px',
                }}
              >
                <WarningIconYELLOW fontSize={isXsScreen ? 'small' : 'medium'} />
              </Grid>
              <Grid item xs>
                <Typography
                  sx={{ ...poppins400, color: '#666666', fontSize: '16px' }}
                >
                  All offers that have not yet been shared with the marketplace
                  will be shared automatically at the commencement of Stage 2.
                </Typography>
              </Grid>
            </Grid>
          )}

          {stageData?.isConditionalMarket == 1 && (
            <Grid
              item
              container
              xs={12}
              sx={{
                display: 'flex',
                flexDirection: 'row',
                border: '1px solid',
                borderColor: '#FF9500',
                padding: 2,
                mt: '30px',
                alignItems: 'center',
              }}
            >
              <Grid
                item
                sx={{
                  display: 'flex',
                  alignItems: 'center',
                  paddingRight: '16px',
                }}
              >
                <WarningIconYELLOW fontSize={isXsScreen ? 'small' : 'medium'} />
              </Grid>
              <Grid item xs={10}>
                <Typography
                  sx={{ ...poppins400, color: '#666666', fontSize: '16px' }}
                >
                  All conditional offers already shared to any buyers privately
                  will be automatically shared to the marketplace at the
                  commencement of Stage 2.
                </Typography>
              </Grid>
            </Grid>
          )}

          <Grid
            item
            container
            direction="row"
            justifyContent={matchesxs ? 'center' : 'flex-end'}
            gap={2}
            marginTop={2}
          >
            <Grid item>
              <Button
                disabled={loaderStage2}
                variant="outlined"
                style={{
                  padding: '10px 39px',
                  width: '100%',
                  height: '41px',
                  fontSize: '14px',
                  color: '#666666',
                  fontWeight: '400',
                  fontFamily: 'Poppins',
                  border: '1px solid rgba(17, 35, 71, 0.1)',
                  borderRadius: '5px',
                  textTransform: 'none',
                }}
                onClick={handleClose}
              >
                Back
              </Button>
            </Grid>
            <Grid item>
              <Button
                variant="outlined"
                disabled={loaderStage2 || unhandledOffersCount != 0}
                onClick={() =>
                  forwardOfferToBuyerFunction([...forwardOfferCheckList])
                }
                style={{
                  padding: '10px 39px',
                  width: '100%',
                  height: '41px',
                  fontSize: '14px',
                  color:
                    loaderStage2 || unhandledOffersCount != 0
                      ? '#C4C4C4'
                      : '#FFFFFF',
                  fontWeight: '400',
                  fontFamily: 'Poppins',
                  background: '#4CA4D6',
                  borderRadius: '5px',
                  textTransform: 'none',
                  cursor:
                    loaderStage2 || unhandledOffersCount != 0
                      ? 'not-allowed'
                      : 'pointer',
                }}
              >
                Confirm
              </Button>
            </Grid>
            {loaderStage2 && (
              <Grid item>
                <img
                  alt="Logo"
                  src={Loading}
                  className="loaderImage"
                  style={{ height: '40px', width: '40px' }}
                />
              </Grid>
            )}
          </Grid>
        </Grid>
      </Dialog>
      <Dialog
        open={openVendorStatusBox}
        PaperProps={{
          sx: {
            borderRadius: '5px',
            minWidth: matchessm ? '100%' : '400px',
            boxShadow: ' -4px, 4px rgba(0, 0, 0, 0.09)',
            padding: '30px',
          },
        }}
      >
        <Grid container height={'100%'}>
          <Grid item xs={12}>
            <Typography
              sx={{ ...poppins400, fontSize: '14px', color: '#666666' }}
            >
              {'   '}
              {address}
              &nbsp;
            </Typography>
          </Grid>
          <Grid
            item
            xs={12}
            display={'flex'}
            alignItems={'center'}
            padding={'20px 0px'}
          >
            <Pendingwarning />
            <Typography
              sx={{ ...poppins500, fontSize: '24px', paddingLeft: '12px' }}
            >
              Notify Buyer - {offerStatus}
            </Typography>
          </Grid>
          <Grid item xs={12} textAlign={'left'} paddingTop={'10px'}>
            <Typography
              sx={{ ...poppins400, fontSize: '18px' }}
              // whiteSpace={"nowrap"}
            >
              You are about to notify{' '}
              <Typography
                component="span"
                sx={{
                  fontFamily: 'Poppins',
                  fontWeight: 600,
                  color: '#666666',
                  fontSize: '18px',
                }}
              >
                {buyerName} {''} {buyerSurName}
              </Typography>{' '}
              of the vendor's response.
            </Typography>
          </Grid>

          <Grid
            item
            container
            direction="row"
            sx={{ display: 'flex', alignItems: 'center' }}
            justifyContent={matchessm ? 'center' : 'flex-end'}
            gap={2}
            marginTop={4}
          >
            <Grid item>
              <Button
                disabled={forwardVendorLoading}
                variant="outlined"
                style={{
                  padding: '10px 39px',
                  width: '100%',
                  height: '41px',
                  fontSize: '14px',
                  color: '#666666',
                  fontWeight: '400',
                  fontFamily: 'Poppins',
                  border: '1px solid rgba(17, 35, 71, 0.1)',
                  borderRadius: '5px',
                  textTransform: 'capitalize',
                }}
                onClick={() => setOpenVendorStatusBox(!openVendorStatusBox)}
              >
                Cancel
              </Button>
            </Grid>
            <Grid
              item
              sx={{
                position: 'relative',
                display: 'flex',
                alignItems: 'center',
              }}
            >
              <Button
                disabled={forwardVendorLoading}
                variant="outlined"
                onClick={() => {
                  let newArr = [];
                  let obj = { offerUniqueId: offerUniqueId };
                  newArr.push(obj);
                  let input = {
                    offerUniqueId: newArr,
                    offerStatus: offerStatus,
                  };
                  if (offerStatus == 'Counter Offer') {
                    input.vendorCounterPrice = offerPriceVendor;
                  }
                  setForwardVendorLoading(true);
                  forwardOfferToBuyer(input)
                    .then((res) => {
                      let successMessage = res?.message;
                      if (res?.status == 1) {
                        if (isNotEmptyArray(res?.dataForBuyerAck))
                          Moxoseparationinlisting(
                            'offerSharingToBuyer',
                            res?.dataForBuyerAck
                          );
                        if (
                          offerStatus == 'Accepted' ||
                          offerStatus == 'Rejected'
                        ) {
                          successMessage = `
              <span style="font-family: Poppins; font-weight: 550; font-size: 16px; color: #666666;"}}>
                ${buyerName} ${buyerSurName}
              </b></span>
              <span style="font-family: Poppins; font-weight: 400; font-size: 16px; color: #666666;">
                has been notified that their offer of 
              </span>
              <span style="font-family: Poppins; font-weight: 550; font-size: 16px; color: #666666;"}}>
                ${offerPrice}
              </b></span>
              <span style="font-family: Poppins; font-weight: 400; font-size: 16px; color: #666666;">
                has been 
              </span>
              <span style="font-family: Poppins; font-weight: 550; font-size: 16px; color: #666666;"}}>
                ${offerStatus}
              </b></span>.`;
                        } else if (offerStatus == 'Counter Offer') {
                          successMessage = `
              <span style="font-family: Poppins; font-weight: 550; font-size: 16px; color: #666666;"}}>
                ${buyerName} ${buyerSurName}
              </b></span>
              <span style="font-family: Poppins; font-weight: 400; font-size: 16px; color: #666666;">
                has been notified the vendor submitted a 
              </span>
              <span style="font-family: Poppins; font-weight: 550; font-size: 16px; color: #666666;"}}>
                Counter offer
              </b></span>
              <span style="font-family: Poppins; font-weight: 400; font-size: 16px; color: #666666;">
                of 
              </span>
              <span style="font-family: Poppins; font-weight: 550; font-size: 16px; color: #666666;"}}>
                ${counterOfferPrice}
              </b></span>.`;
                        }
                        setForwardVendorLoading(false);
                        Swal.fire({
                          title: res?.heading ? res?.heading : 'Success',
                          html: successMessage,
                          showDenyButton: false,
                          showCancelButton: false,
                          icon: 'success',
                          confirmButtonText: 'Close',
                        }).then((result) => {
                          if (result.isConfirmed) {
                            {
                              sharedToMarket != 1 && setShareMarketPlace(true);
                            }
                          } else if (result.isDenied) {
                            return;
                          }
                        });
                        // setForwardVendorLoading(false);
                        setOpenVendorStatusBox(!openVendorStatusBox);
                        getListInfo();
                        offerdata();
                        activityfun();
                      } else {
                        setForwardVendorLoading(false);
                        setOpenVendorStatusBox(!openVendorStatusBox);
                        getListInfo();
                        offerdata();
                        activityfun();

                        Swal.fire({
                          title: res?.heading ? res?.heading : 'Error',
                          text: res?.message,
                          showDenyButton: false,
                          showCancelButton: false,
                          icon: 'error',
                          confirmButtonText: 'Close',
                        }).then((result) => {
                          if (result.isConfirmed) {
                          } else if (result.isDenied) {
                            return;
                          }
                        });
                      }
                    })
                    .catch(() => setForwardVendorLoading(false));
                }}
                style={{
                  padding: '10px 39px',
                  width: '100%',
                  height: '41px',
                  fontSize: '14px',
                  color: '#FFFFFF',
                  fontWeight: '400',
                  fontFamily: 'Poppins',
                  background: '#4CA4D6',
                  borderRadius: '5px',
                  textTransform: 'capitalize',
                }}
              >
                Confirm
              </Button>
              {forwardVendorLoading && (
                <img
                  alt="Logo"
                  src={Loading}
                  className="loaderImage"
                  style={{ height: '40px', width: '40px' }}
                />
              )}
            </Grid>
          </Grid>
        </Grid>
      </Dialog>
      <Dialog
        open={openBox}
        PaperProps={{
          sx: {
            borderRadius: '5px',
            minWidth: matchessm ? '95%' : '400px',
            boxShadow: ' -4px, 4px rgba(0, 0, 0, 0.09)',
            padding: matchessm ? '30px 20px' : '30px',
          },
        }}
      >
        <Grid container height={'100%'}>
          <Grid item xs={12}>
            <Typography
              sx={{
                ...poppins400,
                fontSize: matchessm ? '10px' : '14px',
                color: '#666666',
              }}
            >
              {'   '}
              {address}
              &nbsp;
            </Typography>
          </Grid>
          <Grid
            item
            xs={12}
            display={'flex'}
            alignItems={'center'}
            padding={'12px 0px 15px 0'}
          >
            <Pendingwarning />
            <Typography
              sx={{
                ...poppins500,
                fontSize: matchessm ? '16px' : '24px',
                paddingLeft: '12px',
              }}
            >
              Forward Offer to Vendor
            </Typography>
          </Grid>
          <Grid item textAlign={'left'}>
            <Typography
              sx={{
                ...poppins400,
                fontSize: matchessm ? '12px' : '16px',
                color: '#666666',
              }}
              whiteSpace={'wrap'}
            >
              You are about to forward{' '}
              <Typography component="span">
                <b
                  style={{
                    fontFamily: 'Poppins',
                    fontWeight: 550,
                    fontSize: matchessm ? '12px' : '16px',
                    color: '#666666',
                  }}
                >
                  {buyerName} {''} {buyerSurName}
                </b>
              </Typography>
              's offer of{' '}
              <Typography component="span">
                <b
                  style={{
                    fontFamily: 'Poppins',
                    fontWeight: 550,
                    fontSize: matchessm ? '12px' : '16px',
                    color: '#666666',
                  }}
                >
                  {offerPrice}
                </b>
              </Typography>{' '}
              to the Vendor.
            </Typography>
          </Grid>

          <Grid
            item
            container
            direction="row"
            sx={{ display: 'flex', alignItems: 'center' }}
            justifyContent={'flex-end'}
            gap={2}
            marginTop={matchessm ? '15px' : 5}
          >
            <Grid item>
              <Button
                disabled={frdOfferToVendorLoading}
                variant="outlined"
                style={{
                  padding: matchessm ? '6px 23px' : '10px 39px',
                  width: '100%',
                  height: matchessm ? '35px' : '41px',
                  fontSize: matchessm ? '12px' : '14px',
                  color: '#666666',
                  fontWeight: '400',
                  fontFamily: 'Poppins',
                  border: '1px solid rgba(17, 35, 71, 0.1)',
                  borderRadius: '5px',
                  textTransform: 'none',
                }}
                onClick={() => setOpenBox(!openBox)}
              >
                Cancel
              </Button>
            </Grid>
            <Grid
              item
              sx={{
                position: 'relative',
                display: 'flex',
                alignItems: 'center',
              }}
            >
              <Button
                disabled={frdOfferToVendorLoading}
                variant="outlined"
                onClick={() => {
                  let input = {
                    offerUniqueId: offerUniqueId,
                  };
                  setFrdOfferToVendorLoading(true);
                  forwardOfferToVendor(input)
                    .then((res) => {
                      if (res?.status == 1) {
                        setOpenBox(!openBox);
                        // setUpdatefunc(!updatefunc);
                        setFrdOfferToVendorLoading(false);
                        Swal.fire({
                          title: res?.heading ? res?.heading : 'Success',
                          text: res?.message,
                          showDenyButton: false,
                          showCancelButton: false,
                          icon: 'success',
                          confirmButtonText: 'Close',
                        }).then((result) => {
                          if (result.isConfirmed) {
                          } else if (result.isDenied) {
                            return;
                          }
                        });
                        getListInfo();
                        offerdata();
                        activityfun();
                      } else {
                        setFrdOfferToVendorLoading(false);
                        setOpenBox(!openBox);
                        getListInfo();
                        offerdata();
                        activityfun();

                        Swal.fire({
                          title: res?.heading ? res?.heading : 'Error',
                          text: res?.message,
                          showDenyButton: false,
                          showCancelButton: false,
                          icon: 'error',
                          confirmButtonText: 'Close',
                        }).then((result) => {
                          if (result.isConfirmed) {
                          } else if (result.isDenied) {
                            return;
                          }
                        });
                      }
                    })
                    .catch(() => setFrdOfferToVendorLoading(false));
                }}
                style={{
                  padding: matchessm ? '6px 23px' : '10px 39px',
                  width: '100%',
                  height: matchessm ? '35px' : '41px',
                  fontSize: matchessm ? '12px' : '14px',
                  color: '#FFFFFF',
                  fontWeight: '400',
                  fontFamily: 'Poppins',
                  background: '#4CA4D6',
                  borderRadius: '5px',
                  textTransform: 'none',
                }}
                // disabled={loading}
              >
                Forward
              </Button>
              {frdOfferToVendorLoading && (
                <CircularProgress
                  size={50}
                  sx={{
                    color: '#4CA4D6',
                    marginLeft: '15px',
                    display: 'flex',
                    alignItems: 'center',
                  }}
                />
              )}
            </Grid>
          </Grid>
        </Grid>
      </Dialog>

      {/* FIXED: Acceptance Certificate Dialog */}
      <Dialog
        open={stage2AcceptanceCertificate}
        onClose={() => {
          setStage2AcceptanceCertificate(false);
          // Cleanup blob URL when closing
          if (fileUrl && fileUrl.startsWith('blob:')) {
            URL.revokeObjectURL(fileUrl);
            setFileUrl(null);
          }
        }}
        PaperProps={{
          sx: {
            borderRadius: '5px',
            minWidth: matchessm ? '100%' : '650px',
            boxShadow: ' -4px, 4px rgba(0, 0, 0, 0.09)',
            padding: '30px',
            overflow: 'hidden', // Prevents the dialog from expanding beyond its content
          },
        }}
      >
        <Grid container height={'100%'}>
          <Grid item xs={12}>
            <Typography
              sx={{ ...poppins400, fontSize: '14px', color: '#666666' }}
            >
              {' '}
              {stageData?.PropertyDetails?.propertyAddress?.streetName} &nbsp;
            </Typography>
          </Grid>

          <Grid
            item
            xs={12}
            display={'flex'}
            alignItems={'center'}
            padding={'10px 0px'}
          >
            <Warning />
            <Typography
              sx={{
                ...poppins500,
                fontSize: matchessm ? '20px' : '24px',
                paddingLeft: '12px',
              }}
            >
              Acceptance Certificate
            </Typography>
          </Grid>
          <Grid item xs={12}>
            <div style={{ width: '100%', height: '780px' }}>
              {loading ? (
                <Box
                  sx={{
                    width: '100%',
                    height: '100%', // 🔑 fill parent height
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                  }}
                >
                  <img
                    alt="Logo"
                    src={Loading}
                    className="loaderImage"
                    style={{ height: '75px', width: '75px' }}
                  />
                </Box>
              ) : fileUrl ? (
                <CommonPdfViewer fileUrl={fileUrl} />
              ) : (
                <Box
                  sx={{
                    width: '100%',
                    height: '100%',
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                  }}
                >
                  <p>No PDF file available</p>
                </Box>
              )}
            </div>
          </Grid>

          <Grid
            item
            container
            direction="row"
            justifyContent={matchessm ? 'center' : 'flex-end'}
            gap={2}
            marginTop={2}
          >
            <Grid item>
              <Button
                variant="outlined"
                style={{
                  padding: '10px 39px',
                  width: '100%',
                  height: '41px',
                  fontSize: '14px',
                  color: '#666666',
                  fontWeight: '400',
                  fontFamily: 'Poppins',
                  border: '1px solid rgba(17, 35, 71, 0.1)',
                  borderRadius: '5px',
                }}
                onClick={() => {
                  setStage2AcceptanceCertificate(false);
                  // Cleanup blob URL when closing
                  if (fileUrl && fileUrl.startsWith('blob:')) {
                    URL.revokeObjectURL(fileUrl);
                    setFileUrl(null);
                  }
                }}
              >
                Close
              </Button>
            </Grid>
          </Grid>
        </Grid>
      </Dialog>
      <Dialog
        open={timerresetpopup}
        maxWidth="sm"
        fullWidth
        PaperProps={{
          sx: {
            zIndex: 2000,
          },
        }}
        sx={{
          zIndex: 2000,
        }}
      >
        <DialogTitle
          sx={{
            fontFamily: 'Poppins',
            fontSize: '24px',
            display: 'flex',
            alignItems: 'center',
          }}
        >
          {' '}
          {lessthanstage2 ? <Redwarning /> : <Pendingwarning />} &nbsp; Timer
          Reset Value
        </DialogTitle>
        <DialogContent>
          <DialogContentText>
            <Typography sx={{ fontFamily: 'Poppins' }}>
              {lessthanstage2
                ? 'You must select a Timer Reset value less than Stage 2 Timer'
                : 'You have selected a Stage 2 Timer reset value greater than 6 hours, are you sure ?'}
            </Typography>
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Grid
            container
            xs={12}
            direction="row"
            justifyContent={matchessm ? 'center' : 'flex-end'}
            gap={2}
            padding={2}
            style={{ width: '100%' }}
          >
            <Grid item xs={3}>
              <Button
                variant="outlined"
                style={{
                  padding: '10px 39px',
                  width: '100%',
                  height: '41px',
                  fontSize: '14px',
                  fontWeight: '400',
                  fontFamily: 'Poppins',
                  borderRadius: '5px',
                  textTransform: 'none',
                  cursor: 'pointer',
                }}
                // onClick={() => {
                //   setTimerresetpopup(false);
                //   setTimerreset(0);
                //   setTimer(dayjs().set('hour', 0).set('minute', 30));
                // }}
                onClick={handleTimerResetCancel}
                color="primary"
              >
                {lessthanstage2 ? ' Close' : 'Cancel'}
              </Button>
            </Grid>
            {!lessthanstage2 && (
              <Grid item xs={3}>
                <Button
                  variant="contained"
                  style={{
                    padding: '10px 39px',
                    width: '100%',
                    height: '41px',
                    fontSize: '14px',
                    color: '#FFFFFF',
                    fontWeight: '400',
                    fontFamily: 'Poppins',
                    background: '#4CA4D6',
                    borderRadius: '5px',
                    textTransform: 'none',
                    cursor: 'pointer',
                  }}
                  onClick={handleTimerResetConfirm}
                >
                  Confirm
                </Button>
              </Grid>
            )}
          </Grid>
        </DialogActions>
      </Dialog>
      <Dialog
        open={openStage2Popup}
        onClose={handleStage2PopupClose}
        aria-labelledby="responsive-dialog-title"
        PaperProps={{
          sx: {
            borderRadius: '5px',
            minWidth: matches700 ? '100%' : '721px',
            boxShadow: '-4px 4px rgba(0, 0, 0, 0.09)',
            padding: '30px',
            paddingBottom: matches700 ? '90px' : '',
          },
        }}
      >
        <Grid container height={'100%'}>
          {/* Address */}
          <Grid item xs={12}>
            <Typography
              sx={{ ...poppins400, fontSize: '14px', color: '#666666' }}
            >
              {stageData?.PropertyDetails?.propertyAddress?.streetName}&nbsp;
            </Typography>
          </Grid>
          <Grid
            item
            xs={12}
            display={'flex'}
            alignItems={'center'}
            padding={'12px 0px 15px 0'}
          >
            <Pendingwarning />
            <Typography
              sx={{
                ...poppins500,
                fontSize: matchesxs ? '20px' : '24px',
                paddingLeft: '12px',
              }}
            >
              Commence Stage 2
            </Typography>
          </Grid>
          <Grid item xs={12}>
            <Typography
              sx={{ ...poppins400, fontSize: '16px', color: '#666666' }}
            >
              You are about to commence Stage 2.
            </Typography>
          </Grid>

          <Grid item xs={12}>
            <Divider sx={{ ml: '-30px', mr: '-30px', mt: '30px' }} />
          </Grid>
          {unhandledOffersCount != 0 && (
            <Grid
              item
              container
              xs={12}
              sx={{
                display: 'flex',
                flexDirection: 'row',
                border: '1px solid',
                borderColor: '#FF3830',
                backgroundColor: '#F939391A',
                padding: 2,
                mt: '30px',
                alignItems: 'center',
              }}
            >
              <Grid
                item
                sx={{
                  display: 'flex',
                  alignItems: 'center',
                  paddingRight: '16px',
                }}
              >
                <WarningIconRED fontSize={isXsScreen ? 'small' : 'medium'} />
              </Grid>

              <Grid item xs>
                <Typography
                  sx={{ ...poppins400, color: '#666666', fontSize: '16px' }}
                >
                  Warning! You currently have{' '}
                  <Box
                    component="span"
                    sx={{ ...poppins700, fontSize: '16px', mx: 0 }}
                  >
                    {unhandledOffersCount}
                  </Box>{' '}
                  unhandled offers. Please handle prior to commencing Stage 2.
                </Typography>
              </Grid>
            </Grid>
          )}
          <Grid item xs={12} display="flex" justifyContent="flex-end" mt="40px">
            <Button
              variant="outlined"
              onClick={handleStage2PopupClose}
              sx={{
                padding: '10px 39px',
                width: !matches700 ? '161px' : '100%',
                height: '41px',
                fontSize: '14px',
                color: '#666',
                fontWeight: 400,
                fontFamily: 'Poppins',
                border: '1px solid rgba(17, 35, 71, 0.1)',
                borderRadius: '5px',
                textTransform: 'none',
                padding: '8px 20px',
                backgroundColor: 'transparent',
              }}
            >
              Close
            </Button>
          </Grid>
        </Grid>
      </Dialog>
      {shareMarketPlace && (
        <ShareOfferWithMarketPlace
          shareMarketPlace={shareMarketPlace}
          setShareMarketPlace={setShareMarketPlace}
          getListInfo={getListInfo}
          address={address}
          offerUniqueId={offerUniqueId}
          selectedrowbuyername={buyerName + ' ' + buyerSurName}
          buyerOfferPrice={offerPrice}
        />
      )}
      {modalIsOpen && <Moxochat open={modalIsOpen} onClose={setModalIsOpen} />}
    </React.Fragment>
  );
}

export default CommenceStageTwo;
